<template>
  <div class="page about">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">About</span>
      <HeaderNav />
    </div>

    <div class="page-content" v-if="acf">
      <Components :components="pageData.acf.components" location="above" />

      <div class="page-container">
        <section class="cols">
          <h2>About Big Medium</h2>
          <p v-html="acf.about_big_medium"></p>
        </section>

        <section class="cols">
          <h2>Our Team</h2>
          <div class="teams">
            <div class="team" v-for="team in acf.teams" :key="team.team_name">
              <h3>{{ team.team_name }}</h3>
              <p v-for="member in team.team_members" :key="member.member">{{ member.member.split(',')[0] }}<i v-if="member.member.split(',').length > 1">, {{ member.member.split(',')[1] }}</i></p>
            </div>
          </div>
        </section>

      </div>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

export default {
  name: 'About',
  components: { Components, HeaderNav, Footer },
  mixins: [SubPageUtils],
  data() {
    return {
      pageData: {},
    }
  },
  computed: {
    acf() {
      if (this.pageData.acf) return this.pageData.acf;
    }
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/12732?v=2`)
    this.pageData = await pageDataResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page.about {
  h2 {
    min-width: 25%;
    margin: 0 50px 40px 0;
  }
  p {
    font-size: 20px;
  }

  .cols {
    display: flex;
    margin: 70px 0;
    @media (max-width: @mobile) {
      display: block;
    }
  }

  .teams {
    display: flex;
    flex-wrap: wrap;
    .team {
      width: 33%;
      padding: 0 20px;
      @media (max-width: @mobile) {
        width: 50%;
        padding: 0 20px 0 0;
      }
      h3 {
        font-size: 20px;
        font-weight: bold;
      }
      p {
        margin-bottom: 20px;
        font-weight: 300;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue